export const PANEL_HEADER_HEIGHT = 40;
export const PANEL_FOOTER_HEIGHT = 40;
export const TREE_ROOT_ID = 'XFLOW_TREE_PANEL_ROOT_ID';
//# sourceMappingURL=constants.js.map